// when user clicks load button
// get session storage
// parse storage to become js array
// use same filters (by category, sorting, etc) - copy into sep js file
// for loop render all products if index is gt 5 (double check if starts at 0)
// append to the end of the table inside card - add an id to wrapper
// use bulk as html example
// if there is no session storage, do nothing

document.addEventListener('DOMContentLoaded', function () {
  // Get all View All/View More buttons from CourseBoxMacro
  const viewAllBtns = document.querySelectorAll('[data-category]');

  viewAllBtns.forEach(function (viewAllBtn) {
    viewAllBtn.addEventListener('click', function (e) {
      // console.log('View All button clicked for category:', viewAllBtn.getAttribute('data-category'));

      // Prevent default link behavior
      e.preventDefault();
      const categories = viewAllBtn
        .getAttribute('data-category')
        .split(',')
        .map((c) => c.trim());
      // console.log('Categories:', categories);

      // Get sort type and order from data attributes, default to price/desc alternate is date/asc
      const sortType = viewAllBtn.getAttribute('data-sort-type') || 'price';
      const sortOrder = viewAllBtn.getAttribute('data-sort-order') || 'desc';
      const stateName = viewAllBtn.getAttribute('data-state') || '';

      // Get test price, coupon code, and group id from cookies (if available)
      const testPrice = cart.readCookie && cart.readCookie('_up4tp') ? `&testPrice=${cart.readCookie('_up4tp')}` : '';
      const couponCode = cart.readCookie && cart.readCookie('_up4cc') ? `&couponcode=${cart.readCookie('_up4cc')}` : '';
      const groupId = cart.readCookie && cart.readCookie('_up4gid') ? `&groupId=${cart.readCookie('_up4gid')}` : '';

      // Add loading state
      viewAllBtn.classList.add('btn-processing');

      // Build API URL with dynamic params
      const apiUrl = `apiURL_domain_replaced_during_build/Products/api/v2/Public/GetProductsBy/?host=licensetobuild.com&unpublished=product_unpublished_replaced_during_build&fullSiteBuild=true${testPrice}${couponCode}${groupId}`;

      // console.log('API URL:', apiUrl);

      // Get all products from API and filter by category
      fetch(apiUrl)
        .then((res) => res.json())
        .then((productsData) => {
          // Filter products by marketingCategory
          const nonTestProducts = productsData.filter(
            (p) =>
              (Array.isArray(p.marketingCategory)
                ? p.marketingCategory.some((c) => categories.includes(c))
                : categories.includes(p.marketingCategory)) && p.productCategory?.subCategoryName !== 'Test Product'
          );
          const productList = document.getElementById(viewAllBtn.getAttribute('data-target'));
          // console.log('Filtered products for category:', nonTestProducts);

          // Get IDs of already displayed products
          const displayedProductList = Array.from(productList.querySelectorAll('[data-pid]')).map((el) =>
            el.getAttribute('data-pid')
          );

          // Exclude already displayed products
          let newProductList = nonTestProducts.filter((p) => !displayedProductList.includes(String(p.id)));

          // Remove state prefix from product name
          function removeStatePrefix(name) {
            const states = [
              'Alabama',
              'Alaska',
              'Arizona',
              'Arkansas',
              'California',
              'Colorado',
              'Connecticut',
              'Delaware',
              'Florida',
              'Georgia',
              'Hawaii',
              'Idaho',
              'Illinois',
              'Indiana',
              'Iowa',
              'Kansas',
              'Kentucky',
              'Louisiana',
              'Maine',
              'Maryland',
              'Massachusetts',
              'Michigan',
              'Minnesota',
              'Mississippi',
              'Missouri',
              'Montana',
              'Nebraska',
              'Nevada',
              'New Hampshire',
              'New Jersey',
              'New Mexico',
              'New York',
              'North Carolina',
              'North Dakota',
              'Ohio',
              'Oklahoma',
              'Oregon',
              'Pennsylvania',
              'Rhode Island',
              'South Carolina',
              'South Dakota',
              'Tennessee',
              'Texas',
              'Utah',
              'Vermont',
              'Virginia',
              'Washington',
              'West Virginia',
              'Wisconsin',
              'Wyoming',
            ];
            const trimmed = name.trim();
            const statePattern = states
              .sort((a, b) => b.length - a.length)
              .map((state) => state.replace(/ /g, '\\s+'))
              .join('|');
            const regex = new RegExp('^(' + statePattern + ')\\s+', 'i');
            return trimmed.replace(regex, '') || name;
          }

          // Mirrors arrayCategories/isChildProduct/isPackage in _tasks/products.js
          function arrayCategories(marketingCategory) {
            if (marketingCategory !== null && typeof marketingCategory === 'string') {
              return marketingCategory.split(',').map((c) => c.trim());
            }
            return marketingCategory || [];
          }

          function isChildProduct(marketingCategory) {
            return arrayCategories(marketingCategory).some((c) => c.includes(' - State*'));
          }

          function isPackage(product) {
            const productCategories = arrayCategories(product.marketingCategory);
            const name = product.name || '';
            return (
              productCategories.some((c) => c.toLowerCase().includes('package')) ||
              productCategories.some((c) => c.toLowerCase().includes('bundle')) ||
              name.toLowerCase().includes('package') ||
              name.toLowerCase().includes('bundle')
            );
          }

          function cleanUrlSlug(urlSlug) {
            if (!urlSlug) return urlSlug;
            let slug = urlSlug;
            if (slug.startsWith('/')) slug = slug.substring(1);
            if (slug.endsWith('/')) slug = slug.substring(0, slug.length - 1);
            return slug;
          }

          function productUrl(product) {
            let url = `/product/${cleanUrlSlug(product.urlSlug)}/`;
            if (isChildProduct(product.marketingCategory) && stateName) {
              url += `?state=${stateName}`;
            }
            return url;
          }

          // Sort by price or session date based on parameters
          if (sortType === 'price') {
            // console.log('Sorting by price:', sortOrder);
            newProductList.sort((a, b) => {
              const priceA = parseFloat(a.pricing?.price || 0);
              const priceB = parseFloat(b.pricing?.price || 0);
              if (priceA !== priceB) {
                return sortOrder === 'desc' ? priceB - priceA : priceA - priceB;
              }
              const nameA = (a.name || '').toLowerCase();
              const nameB = (b.name || '').toLowerCase();
              return nameA.localeCompare(nameB, undefined, { numeric: true });
            });
          } else if (sortType === 'name') {
            newProductList.sort((a, b) => {
              const nameA = (a.name || '').toLowerCase().replace(/–/g, '-');
              const nameB = (b.name || '').toLowerCase().replace(/–/g, '-');
              const result = nameA.localeCompare(nameB, undefined, { numeric: true });
              return sortOrder === 'desc' ? -result : result;
            });
          } else if (sortType === 'date') {
            // console.log('Sorting by session date:', sortOrder);
            // Sort by session date (if session exists)
            newProductList.sort((a, b) => {
              // Always use SessionsJSONData if present, fallback to Sessions
              let aSessions = [];
              let bSessions = [];
              if (a.productSettings?.SessionsJSONData) {
                try {
                  const parsedA = JSON.parse(a.productSettings.SessionsJSONData);
                  if (Array.isArray(parsedA)) aSessions = parsedA;
                } catch (e) {}
              }
              if (!aSessions.length && Array.isArray(a.productSettings?.Sessions)) {
                aSessions = a.productSettings.Sessions;
              }
              if (b.productSettings?.SessionsJSONData) {
                try {
                  const parsedB = JSON.parse(b.productSettings.SessionsJSONData);
                  if (Array.isArray(parsedB)) bSessions = parsedB;
                } catch (e) {}
              }
              if (!bSessions.length && Array.isArray(b.productSettings?.Sessions)) {
                bSessions = b.productSettings.Sessions;
              }

              const aSession1 = aSessions.find((s) => s.SessionNumber === 1);
              const bSession1 = bSessions.find((s) => s.SessionNumber === 1);

              // If either session is missing, sort last
              if (!aSession1 && !bSession1) return 0;
              if (!aSession1) return 1;
              if (!bSession1) return -1;

              const aDate = new Date(aSession1.StartDate).getTime();
              const bDate = new Date(bSession1.StartDate).getTime();

              if (aDate !== bDate) {
                return sortOrder === 'desc' ? bDate - aDate : aDate - bDate;
              }
              const aName = (a.name || '').toLowerCase();
              const bName = (b.name || '').toLowerCase();
              return aName.localeCompare(bName, undefined, { numeric: true });
            });
          }

          if (productList && newProductList.length) {
            newProductList.forEach((product) => {
              // Similar details as ProductDetailsLine.njk
              const hours = product.productSettings?.Hours;
              const creditType = product.productSettings?.CreditType;
              const continuingEducationUnits = product.productSettings?.ContinuingEducationUnits;
              const courseFormat = product.productSettings?.CourseFormat;
              const approvalCode = product.productSettings?.CourseApprovalNumber;

              let detailsLine = '';
              if (hours || creditType || continuingEducationUnits || courseFormat || approvalCode) {
                detailsLine += `<div class="mt-2 mb-2 fw-600">`;
                if (hours) {
                  const hourLabel = Number(hours) <= 1 ? 'hour' : 'hours';
                  detailsLine += `<span>${hours} ${hourLabel}</span>`;
                }
                if (creditType) detailsLine += `<span> | ${creditType} Credits</span>`;
                if (continuingEducationUnits) {
                  const ceuLabel = Number(continuingEducationUnits) <= 1 ? 'CEU' : 'CEUs';
                  detailsLine += `<span> | ${continuingEducationUnits} ${ceuLabel}</span>`;
                }
                if (courseFormat) detailsLine += `<span> | ${courseFormat} Course</span>`;
                if (approvalCode) detailsLine += `<span> | Course Approval # ${approvalCode}</span>`;
                detailsLine += `</div>`;
              }

              // Similar to PackageContents.njk + PackageModal.njk
              const bundleContents = product.bundleContents || [];
              const packageContents = bundleContents.length
                ? `<p><a class="me-4" href="#" data-bs-toggle="modal" data-bs-target="#packageModal-${product.id}" role="button">&raquo; View Package Content</a></p>`
                : '';
              const packageModal = bundleContents.length
                ? `
                  <div class="modal fade package-modal" id="packageModal-${
                    product.id
                  }" tabindex="-1" aria-labelledby="packageModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                      <div class="modal-content">
                        <div class="modal-body p-3">
                          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                          <div class="row justify-content-center px-3">
                            <div class="card p-0 overflow-hidden border-0">
                              <div class="card-body py-2 px-0">
                                <h3 id="package-title" class="h4 text-dark">${removeStatePrefix(product.name)}</h3>
                                <ul class="mb-0">
                                  ${bundleContents.map((bp) => `<li>${removeStatePrefix(bp.name)}</li>`).join('')}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                `
                : '';

              const productPackage = isPackage(product);
              const ribbon = productPackage ? `<div class="ribbon"><span>Package</span></div>` : '';
              const url = productUrl(product);
              const imgSrc = product.productSettings?.ProductImageUrl || '/images/fallback-post-image.jpg';
              const name = removeStatePrefix(product.name);

              // Product HTML mirrors verticalRow macro in CourseBoxMacro.njk
              let html = `
                <div class="col-sm-10 col-md-6 col-xl-4 d-flex" data-pid="${product.id}">
                  <div class="card course-box vertical vertical-row boxed-hover w-100 mb-3 mb-md-4 ${
                    productPackage ? 'package' : ''
                  }">
                    ${ribbon}
                    <div class="card-body pb-2">
                      <div class="d-flex mb-2">
                        <a class="course-img img bg-light rounded overflow-hidden me-3" href="${url}">
                          <img class="card-img-top img-fluid" src="${imgSrc}" alt="${name}" width="400" height="400" loading="lazy" />
                        </a>
                        <h3 class="h5 text-theme-secondary mb-0"><a href="${url}">${name}</a></h3>
                      </div>
                      ${detailsLine}
                      <div class="mb-2">
                        ${product.description || ''}
                      </div>
                      ${packageContents}
                    </div>
                    <div class="card-footer action bg-transparent border-0 mt-auto w-100 pt-0 pb-4">
                      <a class="add-to-cart-btn btn btn-outline-secondary me-2" href="#" data-pid="${
                        product.id
                      }" data-cart="add">Add to Cart</a>
                      <span class="regular-price slashprice me-2" data-pid="${product.id}"></span>
                      <span class="price-display" data-pid="${product.id}"></span>
                    </div>
                  </div>
                </div>
                ${packageModal}
              `;
              productList.insertAdjacentHTML('beforeend', html);
              cart.initAddToCartBtns();
            });

            // Fill in prices for the newly inserted cards (same mechanism as pricing.js on page load)
            // must pass the full productsData, not just newProductList, since displayPrice also
            // hides any on-page card whose pid isn't found in the list it's given
            if (window.pricing && typeof pricing.displayPrice === 'function') {
              pricing.displayPrice(productsData);
            }

            // Hide button when no more products to load
            viewAllBtn.style.display = 'none';
          }

          // Remove loading state after products are rendered
          viewAllBtn.classList.remove('btn-processing');
        })
        .catch(() => {
          // Remove loading state on error
          viewAllBtn.classList.remove('btn-processing');
        });
    });
  });
});
